import Customers from './Customers';

import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import AtolyeTable from 'components/AtolyeTable';
import ContentWrapper from 'components/shared/ContentWrapper';
import Footer from 'components/shared/Footer/Footer';
import Header from 'components/shared/Header';
import PageTitle from 'components/shared/PageTitle';
import PageWrapper from 'components/shared/PageWrapper';

import { useCustomers, useUser } from 'hooks';

export default Customers;

export {
  AtolyeTable,
  Button,
  ContentWrapper,
  Footer,
  Header,
  Link,
  PageTitle,
  PageWrapper,
  useCustomers,
  useUser,
};
